import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React, { FC, useState } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { BuyQuantityProducts } from '@Domains/Product/Features/Display/Info/Info'
import { Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './BuyButtonArea.module.scss'

interface BuyButtonAreaProps {
  buyPersonalizationId?: string | null
  buyQuantitySelection: BuyQuantityProducts
  product: Product
  selectedCrossSellIDs: string[]
  selectedVariantID: string
  variantsInTotal: number
}

export const BuyButtonArea: FC<BuyButtonAreaProps> = ({
  buyPersonalizationId,
  buyQuantitySelection,
  product,
  selectedCrossSellIDs,
  selectedVariantID,
  variantsInTotal,
}) => {
  const { t } = useTranslation()
  const [promptsOpen, setPromptsOpen] = useState(false)

  return (
    <div className={clsx(styles.stickyBoxWrapper, !promptsOpen && styles.stickyBox)}>
      <div className={styles.wrapper} data-intersection-id="add-to-cart-trigger">
        <div className={styles.box}>
          <BuyButtonV2
            className={clsx(styles.buyButton)}
            color="black"
            onPromptChange={setPromptsOpen}
            productID={product.id}
            products={[
              {
                productID: product.id,
                quantity: buyQuantitySelection.quantity,
                variantID: selectedVariantID,
              },
              ...(buyPersonalizationId
                ? [
                  {
                    productID: buyPersonalizationId,
                    parentIndex: 0,
                  },
                ]
                : []),
              ...(isEmpty(selectedCrossSellIDs)
                ? []
                : selectedCrossSellIDs.map(productID => ({
                  productID,
                  quantity: 1,
                }))),
            ]}
            quantity={buyQuantitySelection.quantity}
            variantID={selectedVariantID}
          >
            {variantsInTotal > 1
              ? (
                <>
                  {t('products:CHOOSE_SIZE')}
                  <SvgAngleRight className={styles.icon} />
                </>
              )
              : t('cms:ADD_TO_CART')}
          </BuyButtonV2>
        </div>
      </div>
    </div>
  )
}
